<template>
<div class="grid">



<div class="col-12" v-if="report">





<DataTable 
:value="listitems" 
:lazy="true" 
:paginator="true" 
class="p-datatable-suppliers" 
:rows="rows"
:page="page+1"
:first="first"
:totalRecords="totalRecords"
dataKey="id" 
:rowHover="true" 
v-model:filters="filters" 
filterDisplay="menu" 
:loading="loading"
@page="onPage($event)" 
@sort="onSort($event)" 
@filter="onFilter($event)"
paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport" 
:rowsPerPageOptions="[5,10,25,50,100]"
currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
:globalFilterFields="globalfilterfields" 
responsiveLayout="scroll"
@update:filters="updateFilters"
>

<template #header>
<div class="grid">
<div class="col-12 ">
<div style="text-align:left">
 <!-- <MultiSelect :modelValue="selectedcolumns" :options="columns" optionLabel="header" @update:modelValue="onToggle"    
      display="chip" placeholder="Select Columns" />-->
</div>
</div>
</div>
</template>


<template #empty>
<div class="grid">
<div class="col-12">
<div class="flex justify-content-start align-items-center my-6">
<h3 class="text-primary ml-6" >{{$store.state.languages.lang_phrases.rapor_verisi_bulunamadi}}</h3>
</div>
</div>
</div>
</template>

<template #loading>
<div class="loading_overlay">
<p>Preparing Report...</p>
<br/>
<div class="percentage_wrap">
<ProgressBar :value="percentage" :showValue="false" v-if="percentage!==100"> </ProgressBar>
</div>
</div>
</template>


<Column 
field="name" 
:header="$store.state.languages.lang_phrases.tedarikci_ismi"  
style="min-width: 15rem;max-width:20rem" 
:showFilterMatchModes="false"
>
<template #filter="{filterModel,filterCallback}">
<InputText v-model="filterModel.value" type="text" class="p-column-filter" :placeholder="$store.state.languages.lang_phrases.firma_ismi_ile_arama" />
</template>
<template #filterclear="{ filterCallback }">
    <Button :label="$store.state.languages.lang_phrases.sifirla"  class="p-button-outlined p-button-sm p-button-primary" :loading="$store.state.ui.submitting" type="button" @click="filterCallback()"></Button>
</template>
<template #filterapply="{ filterCallback }">
  <Button :label="$store.state.languages.lang_phrases.filtrele"  class="p-button-sm p-button-primary" :loading="$store.state.ui.submitting" type="button" @click="filterCallback('test')"></Button>
</template>

<template #body="{data}">
<router-link  class="text-primary p-link no-underline" tag="span" :to="{ name: 'Supplier' , params: {id:data.supplier_id}}">{{data.supplier.name}}</router-link>
</template>

</Column>


<Column 
field="suppliercode" 
:header="$store.state.languages.lang_phrases.tedarikci_kodu"  
style="min-width: 14rem" 
:showFilterMatchModes="false">

<template #filter="{filterModel,filterCallback}">
<InputText v-model="filterModel.value" type="text" class="p-column-filter" :placeholder="$store.state.languages.lang_phrases.firma_kodu_ile_arama" />
</template>
<template #filterclear="{ filterCallback }">
    <Button :label="$store.state.languages.lang_phrases.sifirla"  class="p-button-outlined p-button-sm p-button-primary" :loading="$store.state.ui.submitting" type="button" @click="filterCallback()"></Button>
</template>
<template #filterapply="{ filterCallback }">
  <Button :label="$store.state.languages.lang_phrases.filtrele"  class="p-button-sm p-button-primary" :loading="$store.state.ui.submitting" type="button" @click="filterCallback()"></Button>
</template>

<template #body="{data}">
<p>{{data.supplier.suppliercode}}</p>
</template>
</Column>


<!-- columns -->
<template v-for="(column,index) in selectedcolumns" :key="column.id">

<Column   
style="min-width: 14rem" 
:filterMenuStyle="{'width':'28rem'}"
:showFilterMenu="column.filterable"
:field="column.id.toString()"
:showFilterMatchModes="false"

>
<template #header>
  <span class="p-column-title" @click="showColumn(column.id)">{{getTitleTranslation(column.id)}}</span>
</template>



<template #filter="{filterModel,filterCallback}" v-if="column.filteroptions && column.filteroptions.filtertype!=='multiselect' && column.filteroptions.filtertype!=='listselect'">

  <template v-if="column.filteroptions.type=='questionlist_points' 
  || column.filteroptions.type=='questionlist_nonconformity_count' 
  || column.filteroptions.type=='section_points' 
  || column.filteroptions.type=='inputfield_point'
  || column.filteroptions.type=='questionlist_custom_points'">
  <div class="grid">
  <div class="col-6">
    <span class="p-float-label mt-2" >
        <InputNumber :id="column+'number'" v-model="filterModel.value[0]" />
        <label :for="column+'number'">Min</label>
    </span>
  </div>
  <div class="col-6">
    <span class="p-float-label  mt-2" >
        <InputNumber :id="column+'number'" v-model="filterModel.value[1]" />
        <label :for="column+'number'">Max</label>
    </span>
  </div>
  </div>
           
  </template>
  <template v-if="column.filteroptions.type=='verification_date'
  || column.filteroptions.type=='audit_date'">
    <div>
        <br/><br/>
      <Calendar v-model="filterModel.value" 
      selectionMode="range" 
      :manualInput="false" 
      showButtonBar
      inline
      panelClass="filtercalendar"
      :hideOnRangeSelection="true"/>
    </div>

  </template>

  <template v-if="column.filteroptions.type=='inputfield_null_reason'
  || column.filteroptions.type=='verification_status'
  || column.filteroptions.type=='audit_status'
  || column.filteroptions.type=='project_status' 
  || column.filteroptions.type=='flow_status'">
      <MultiSelect v-model="filterModel.value" :options="column.filterselectors" placeholder="Hepsi" class="p-column-filter" :showClear="true" display="chip" filter >
        
        <template #chip="slotProps">
          {{getTheTranslation(slotProps.value,'translation')}}
        </template>
        <template #option="slotProps">
            <span :class="'customer-badge status-' + slotProps.option">{{getTheTranslation(slotProps.option,'translation')}}</span>
        </template>
    </MultiSelect>
  </template>
  <!-- custom_attribute -->
  <template v-if="column.filteroptions.type=='inputfield_submission'">
    <template v-if="column.filteroptions.filtertype">

      <template v-if="column.filteroptions.filtertype=='number'">
        <div class="grid">
        <div class="col-6">
          <span class="p-float-label mt-2" >
              <InputNumber :id="column+'number'" v-model="filterModel.value[0]" />
              <label :for="column+'number'">Min</label>
          </span>
        </div>
        <div class="col-6">
          <span class="p-float-label  mt-2" >
              <InputNumber :id="column+'number'" v-model="filterModel.value[1]" />
              <label :for="column+'number'">Max</label>
          </span>
        </div>
        </div>
      </template>


      <template v-if="column.filteroptions.filtertype=='select'">
        <MultiSelect v-model="filterModel.value" :options="column.filterselectors" placeholder="Hepsi" class="p-column-filter" :showClear="true" display="chip" filter optionValue="id" optionLabel="name">        
          
          <template #option="slotProps">
              <span :class="'customer-badge status-' + slotProps.option">{{getTheTranslation(slotProps.option,'translation')}}</span>
          </template>
      </MultiSelect>
      </template>


      <template v-if="column.filteroptions.filtertype=='text'">
        <InputText v-model="filterModel.value" type="text" class="p-column-filter" :placeholder="$store.state.languages.lang_phrases.arama" />
      </template>
      
    </template>

  </template>


  <!-- custom_attribute -->
  <template v-if="column.filteroptions.type=='custom_attribute'">
    <MultiSelect 
    v-model="filterModel.value" 
    v-if="column.filteroptions.attribute_type=='select' 
    || column.filteroptions.attribute_type=='boolean'
    || column.filteroptions.attribute_type=='categorised'
    || column.filteroptions.attribute_type=='cascadecategorised'
    "
    :options="column.filterselectors" 
    placeholder="Hepsi" 
    class="p-column-filter" 
    :showClear="true" 
    display="chip" 
    filter >        
        <template #chip="slotProps">
          {{getTheTranslation(slotProps.value,'translation')}}
        </template>
        <template #option="slotProps">
            <span :class="'customer-badge status-' + slotProps.option">{{getTheTranslation(slotProps.option,'translation')}}</span>
        </template>
    </MultiSelect>

    <template v-if="column.filteroptions.attribute_type=='number'">
      <div class="grid">
      <div class="col-6">
        <span class="p-float-label mt-2" >
            <InputNumber :id="column+'number'" v-model="filterModel.value[0]" />
            <label :for="column+'number'">Min</label>
        </span>
      </div>
      <div class="col-6">
        <span class="p-float-label  mt-2" >
            <InputNumber :id="column+'number'" v-model="filterModel.value[1]" />
            <label :for="column+'number'">Max</label>
        </span>
      </div>

      </div>
      
    </template>


  </template>
  <!-- custom_attribute -->


    
</template>

<template #filterclear="{ filterCallback }">
    <Button :label="$store.state.languages.lang_phrases.sifirla"  class="p-button-outlined p-button-sm p-button-primary" :loading="$store.state.ui.submitting" type="button" @click="filterCallback()"></Button>
</template>
<template #filterapply="{ filterCallback }">
  <Button :label="$store.state.languages.lang_phrases.filtrele"  class="p-button-sm p-button-primary" :loading="$store.state.ui.submitting" type="button" @click="filterCallback()"></Button>
</template>




<template #body="slotProps">


<template v-if="getCellValue(slotProps.data.id,column.id) || getCellValue(slotProps.data.id,column.id) ===0">
<AnalyticsListOutputCell :data="getCellValue(slotProps.data.id,column.id)" :column="column" />
</template>
<template v-else>
  <i class="pi pi-times-circle text-red-500" @click="check(slotProps.data.id,column.id)"></i>
</template>


</template>

</Column>


</template>
<!-- columns -->







</DataTable>


</div>
</div>
</template>

<script>
import {FilterMatchMode,FilterOperator} from 'primevue/api';
import AnalyticsListOutputCell from "./AnalyticsListOutputCell"


let boolean_statuses = [          
          {name:"Açık",id:1},
          {name:"Kapalı",id:0},
        ]

export default {
  name: 'AnalyticsListOutput',

  data () {
    return {
    	loading:true,
      report:null,
      columns:[],
      selectedcolumns:[],
      columncounter:0,
      percentage:0,
      listitems:[],
      last_searched_column:null,
      rows:10,
      page:0,
      first:0,
      sort_column:"",
      sort_order:1,
      totalRecords:0,
      selectedSuppliers:[],
      globalfilterfields:['name','suppliercode'],
      hidden_columns:[],
      sorted_filters:null,
      filters: {
        'global': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'name': {value: null, matchMode: FilterMatchMode.CONTAINS},
        'suppliercode': {value: null, matchMode: FilterMatchMode.CONTAINS},
      },
    }
  },
  components:{AnalyticsListOutputCell},
  computed:
  {
    statuses()
    {
        let arr = [        
        {name:this.$store.state.languages.lang_phrases.olusturuldu,id:"created"},
        {name:this.$store.state.languages.lang_phrases.goruntulendi,id:"viewed"},
        {name:this.$store.state.languages.lang_phrases.baslandi,id:"started"},
        {name:this.$store.state.languages.lang_phrases.tamamlandi0,id:"finished"},
        {name:this.$store.state.languages.lang_phrases.degerlendirmede,id:"under_review"},
        {name:this.$store.state.languages.lang_phrases.iptal_edildi,id:"canceled"},
        {name:this.$store.state.languages.lang_phrases.duzeltme_talebi_incelemede,id:"correction_requested"},
        ]
        return  arr
    },
    schedulestatuses()
    {
        let arr = [        
        {name:this.$store.state.languages.lang_phrases.olusturuldu,id:"created"},
        {name:this.$store.state.languages.lang_phrases.planlandi,id:"scheduled"},
        {name:this.$store.state.languages.lang_phrases.tekrar_planlandi,id:"rescheduled"},
        {name:this.$store.state.languages.lang_phrases.tamamlandi0,id:"finished"},
        {name:this.$store.state.languages.lang_phrases.degerlendirmede,id:"under_review"},
        {name:this.$store.state.languages.lang_phrases.iptal_edildi,id:"canceled"},
        {name:this.$store.state.languages.lang_phrases.muaf,id:"exempt"},
        ]
        return  arr
    },
    cellclass()
    {
      if(this.report.columns.length>5)
      {
        return "customtable_cell"
      }
      else
      {
        return "customtable_cell_wide"
      }
    },
    visibleColumns()
    {

    },
  },
  async mounted()
  {
    this.report = await this.generalApiGetWithoutLoader("brand_report_columns/"+this.$route.params.report_id)
    await this.prepareColumns()
    await this.getData()
  },
  methods:{
    updateFilters(data)
    {
      
      let filters = this.sanitizeArray(this.filters)

      for (const property in filters) {
        //console.log(`${property}: ${filters[property]}`);
        
        if(filters[property].filtertype=="inputfield_submission")
        {
          if(!filters[property].value)
          {
            if(filters[property].object_type=="text")
            {
              filters[property].value = null
            }
            else if(filters[property].object_type=="select")
            {
              filters[property].value = []
            }
            else
            {
              filters[property].value = [null,null]
            }
            
          }
        }
      }
      this.filters = filters
    },
    showColumn(id)
    {
      console.log(this.columns)
      let col = this.columns.find(item=>item.id == id)
      console.log(col)
      console.log(this.filters)
    },
    async prepareColumns()
    {
      let columns = this.report.columns
      let columncounter = this.report.columns.length
      let percentage_piece = 100/columncounter
      for(let column of columns)
      {        
        let filter_obj
        let filteroptions = JSON.parse(column.filteroptions)
        column.filteroptions = JSON.parse(column.filteroptions)
        if(filteroptions)
        {
            //project_status
            filter_obj = {value: null, matchMode: FilterMatchMode.EQUALS,filtertype:filteroptions.type} 
            if(filteroptions.type=="project_status" || filteroptions.type=="flow_status")
            {
                         
              column.filterselectors = []

              let phrases  = ["olusturuldu","goruntulendi","baslandi","tamamlandi0","degerlendirmede","iptal_edildi","duzeltme_talebi_incelemede"]
              for(let phrase of phrases)
              {
                let the_translation = await this.generalApiGetWithoutLoader("language/get_item_translation/"+phrase)
                let obj = {
                    name:the_translation.original,
                    id:null,
                    translations:the_translation.translations
                  }
                if(phrase=="olusturuldu")
                {
                  obj.id = "created"
                }
                if(phrase=="goruntulendi")
                {
                  obj.id = "viewed"
                }
                if(phrase=="baslandi")
                {
                  obj.id = "started"
                }
                if(phrase=="tamamlandi0")
                {
                  obj.id = "finished"
                }
                if(phrase=="degerlendirmede")
                {
                  obj.id = "under_review"
                }
                if(phrase=="iptal_edildi")
                {
                  obj.id = "canceled"
                }
                if(phrase=="iptal_edildi")
                {
                  obj.id = "canceled"
                }
                if(phrase=="duzeltme_talebi_incelemede")
                {
                  obj.id = "correction_requested"
                }
                column.filterselectors.push(obj)

              }
              
            }
            //project_status

            //verification_status
            if(filteroptions.type=="verification_status" || filteroptions.type=="audit_status")
            {
                         
              column.filterselectors = []

              let phrases  = ["olusturuldu","tamamlandi0","degerlendirmede","iptal_edildi","planlandi","tekrar_planlandi","muaf"]
              for(let phrase of phrases)
              {
                let the_translation = await this.generalApiGetWithoutLoader("language/get_item_translation/"+phrase)
                let obj = {
                    name:the_translation.original,
                    id:null,
                    translations:the_translation.translations
                  }
                if(phrase=="olusturuldu")
                {
                  obj.id = "created"
                }
                if(phrase=="planlandi")
                {
                  obj.id = "scheduled"
                }
                if(phrase=="tekrar_planlandi")
                {
                  obj.id = "rescheduled"
                }
                if(phrase=="tamamlandi0")
                {
                  obj.id = "finished"
                }
                if(phrase=="degerlendirmede")
                {
                  obj.id = "under_review"
                }
                if(phrase=="iptal_edildi")
                {
                  obj.id = "canceled"
                }
                if(phrase=="muaf")
                {
                  obj.id = "exempt"
                }
                column.filterselectors.push(obj)

              }
              
            }
            //verification_status
            //custom_attribute
            if(filteroptions.type=="custom_attribute")
            {
               
              let custom_attribute = await this.generalApiGetWithoutLoader("custom_attributes/brand_attribute/"+column.relateditem_id)

              if(custom_attribute)
              {
                column.customattribute = custom_attribute
                column.filteroptions.attribute_type = custom_attribute.type
                //select
                if(custom_attribute.type=="select")
                {
                  filter_obj = {value: null, matchMode: FilterMatchMode.EQUALS,filtertype:filteroptions.type,attribute_type:custom_attribute.type}
                   let custom_attribute_options = await this.generalApiGetWithoutLoader("custom_attributes/options/"+column.relateditem_id)
                   if(custom_attribute_options.length)
                   {
                    column.filterselectors = custom_attribute_options
                   }

                }
                //select
                //boolean
                if(custom_attribute.type=="boolean")
                {
                  filter_obj = {value: null, matchMode: FilterMatchMode.EQUALS,filtertype:filteroptions.type,attribute_type:custom_attribute.type}
                  column.filterselectors = this.sanitizeArray(boolean_statuses)
                }
                //boolean
                if(custom_attribute.type=="number")
                {
                  filter_obj = { value: [null, null], matchMode: FilterMatchMode.BETWEEN ,filtertype:filteroptions.type,attribute_type:custom_attribute.type}
                }
                //boolean
                //boolean
                if(custom_attribute.type=="categorised" || custom_attribute.type=="cascadecategorised")
                {
                  filter_obj = {value: null, matchMode: FilterMatchMode.EQUALS,filtertype:filteroptions.type,attribute_type:custom_attribute.type}
                   let custom_attribute_options = await this.generalApiGetWithoutLoader("custom_attributes/categories/"+column.relateditem_id)
                   if(custom_attribute_options.length)
                   {
                    column.filterselectors = custom_attribute_options
                   }
                }
                //boolean

              }

            }
            //custom_attribute
            //numerical
            if(filteroptions.type=="questionlist_points" ||filteroptions.type=="questionlist_nonconformity_count"||filteroptions.type=="section_points" || filteroptions.type=="inputfield_point" || filteroptions.type=="questionlist_nonconformity_count" || filteroptions.type=="questionlist_custom_points")
            {
              filter_obj = { value: [null, null], matchMode: FilterMatchMode.BETWEEN ,filtertype:filteroptions.type}
            }
            //numerical
            //inputfield_null_reason
            if(filteroptions.type=="inputfield_null_reason")
            {

              let the_inputfield = await this.generalApiGetWithoutLoader("questionlists/inputfield/"+column.relateditem_id)
              column.filterselectors = await this.generalApiGetWithoutLoader("questionlistnullreasons/"+the_inputfield.questionlist_id)
              
              filter_obj = {value: null, matchMode: FilterMatchMode.EQUALS,filtertype:filteroptions.type} 
              
            }
            if(filteroptions.type=="verification_date"||filteroptions.type=="audit_date")
            {
              
              filter_obj = {value: [], matchMode: FilterMatchMode.IN,filtertype:filteroptions.type} 
              
            }
            //inputfield_null_reason
            //inputfield_submission
            if(filteroptions.type=="inputfield_submission")
            {
              filter_obj = { value: [null, null], matchMode: FilterMatchMode.BETWEEN ,filtertype:filteroptions.type}
              let the_inputfield = await this.generalApiGetWithoutLoader("questionlists/inputfield/"+column.relateditem_id)
              /////////////
              if(the_inputfield.type=="select" || the_inputfield.type=="multiselect" || the_inputfield.type == "listselect")
              {

                filter_obj = {value: null, 
                  matchMode: FilterMatchMode.EQUALS,
                  filtertype:filteroptions.type,
                  object_type:the_inputfield.type}  

                column.filteroptions.filtertype = the_inputfield.type
                if(the_inputfield.questionlist.type=="same_question_pattern")
                {
                  column.filterselectors = await this.generalApiGetWithoutLoader("questionlists/inputfield/options_for_same_type_pattern/"+column.relateditem_id)
                }
                else
                {
                  column.filterselectors = await this.generalApiGetWithoutLoader("questionlists/inputfield/options/"+column.relateditem_id)
                }
                
              }
              /////////////
              if(the_inputfield.type=="columns")
              {

                let inputfield_column = await this.generalApiGetWithoutLoader("questionlists/inputfield/column/"+filteroptions.column_id)
                if(inputfield_column.type=="select")
                {
                  column.filteroptions.filtertype = "select"

                  filter_obj = {value: null, 
                    matchMode: FilterMatchMode.EQUALS,
                    filtertype:filteroptions.type,
                    object_type:"select"} 

                  column.filterselectors = inputfield_column.options
                }
                if(inputfield_column.type=="number" || inputfield_column.type=="custom")
                {
                  column.filteroptions.filtertype = "number"
                  filter_obj = { value: [null, null], 
                    matchMode: FilterMatchMode.BETWEEN ,
                    filtertype:filteroptions.type,
                    object_type:"number"}
                }
                if(inputfield_column.type=="text")
                {
                  column.filteroptions.filtertype = "text"
                  filter_obj = {value: null, 
                    matchMode: FilterMatchMode.CONTAINS,
                    filtertype:filteroptions.type,
                    object_type:"text"}
                }
              }
              /////////////
              if(the_inputfield.type=="number")
              {
                column.filteroptions.filtertype = "number"
                filter_obj = { value: [null, null], 
                  matchMode: FilterMatchMode.BETWEEN ,
                  filtertype:filteroptions.type,
                  object_type:"number"}
              }
              /////////////
              if(the_inputfield.type=="text" || the_inputfield.type=="longtext")
              {
                column.filteroptions.filtertype = "text"
                filter_obj = {value: null, 
                  matchMode: FilterMatchMode.CONTAINS,
                  filtertype:filteroptions.type,
                  object_type:"text"}
              }
              
            }
            //inputfield_submission

            this.filters[column.id.toString()] = filter_obj
            this.globalfilterfields.push(column.id.toString())
            
            

        }
        
        if(column.sortable===1)
        {
          column.sortable = true
        }
        else
        {
          column.sortable = false
        }

        if(column.filterable===1)
        {
          column.filterable = true
        }
        else
        {
          column.filterable = false
        }
        this.percentage += percentage_piece
        if(this.percentage>100)
        {
          this.percentage = 100
        }
      }
      if(this.percentage<100)
        {
          this.percentage = 100
        }
      this.columns = columns
      this.selectedcolumns = columns
      console.log(this.columns)
    },
    check(id,column)
    {
      console.log(this.getCellValue(id,column))
    },
    onToggle(value)
    {
      console.log(value)        
      let result = this.selectedcolumns.filter(o1 => !this.columns.some(o2 => o1.id === o2.id));
      this.selectedcolumns = result
    },
    logCellvalue(listitem_id,column_id)
    {
      console.log("logCellvalue")
      
      let list_item = this.listitems.find((item)=>{return item.id == listitem_id})
      let data = list_item.brandreportitems.find((item)=>{return item.brandreportcolumn_id == column_id})
     
      if(data && data.textval)
      {
        return data.textval
      }
      if(data && data.numericalval)
      {        
        return this.$filters.numberformat( data.numericalval)
      }
      else
      {
        if(data.numericalval===0)
        {        
          return this.$filters.numberformat( data.numericalval)
        }
      }
      

      
    },
    getCellValue(listitem_id,column_id)
    {
     
      //console.log(listitem_id)
      let list_item = this.listitems.find((item)=>{return item.id == listitem_id})
      let data = list_item.brandreportitems.find((item)=>{return item.brandreportcolumn_id == column_id})
      

      if(data)
      {
        if(data.textval)
        {
          return data.textval
        }
        if(data.dateval)
        {
          return data.dateval
        }
        if(data.numericalval)
        {
          return data.numericalval
        }
        if(data.numericalval===0)
        {        
          return data.numericalval
        }
      }
      else
      {
        return null
      }
      
    },
    sortByColumn(column)
    {
      
      let column_index = this.report.listitems[0].output.findIndex((item)=>{return item.column_id == column.id})
      this.report.listitems = this.sortByColumn(column_index)
    },
    columnSort(column_index)
    {
      let arr = this.report.listitems.sort((a, b) => a.output[column_index].value - b.output[column_index].value)
      return arr
    },
    sortFilters()
    {
      console.log(this.filters)
      let filters = this.sanitizeArray(this.filters)
      let arr = []
      for(let filter in filters)
      {
        
        let filter_name = filter
        let filter_obj = filters[filter]
        /*
        console.log("filter_obj")
        console.log(filter_obj)
        console.log(filter)
        */
        if(filter=="name" && filter_obj.value)
        {          
          let obj = {
            id:filter_name,
            type:"name",
            value:filter_obj.value
          }
          arr.push(obj)
        }
        if(filter=="suppliercode" && filter_obj.value)
        {          
          let obj = {
            id:filter_name,
            type:"suppliercode",
            value:filter_obj.value
          }
          arr.push(obj)
        }
        let type = filter_obj.filtertype
        let obj = {
          id:filter_name,
          type:type,
        }
        ////////////
        if(type=="project_status"
          ||type=="flow_status"
          ||type=="verification_status"
          ||type=="audit_status"
          ||type=="inputfield_null_reason")
        {
          
          if(filter_obj.value && filter_obj.value.length)
          {
            let elements = filter_obj.value.map(item=>item.id)
            obj.ids = elements
            arr.push(obj)
          }          
        }
        ////////////
        if(type=="custom_attribute")
        {
          if(filter_obj.attribute_type=="select"
            ||filter_obj.attribute_type=="boolean"
            ||filter_obj.attribute_type=="categorised"
            ||filter_obj.attribute_type=="cascadecategorised")
          {
            if(filter_obj.value && filter_obj.value.length)
            {
              let elements = filter_obj.value.map(item=>item.id)
              obj.ids = elements
              arr.push(obj)
            } 

          }
          if(filter_obj.attribute_type=="number")
          {
            if(filter_obj.value && filter_obj.value.length)
            {
              if(filter_obj.value[1] || filter_obj.value[0])
              {
                obj.max = filter_obj.value[1]
                obj.min = filter_obj.value[0]
                arr.push(obj)
              }
            }
          }
        }
        ////////////
        if(type=="supplier_location"
          ||type=="supplier_users"
          ||type=="last_supplier_conversation"
          ||type=="inputfield_nonconformity_count"
          ||type=="verification_auditor"
          ||type=="audit_auditor")
        {

        }
        ////////////
        if(type=="verification_date"
          ||type=="audit_date")
        {

          if(filter_obj.value && filter_obj.value.length)
            {
              if(filter_obj.value[1] || filter_obj.value[0])
              {
                obj.max = filter_obj.value[1]
                obj.min = filter_obj.value[0]
                arr.push(obj)
              }
            }
        }
        ////////////
        if(type=="questionlist_points"||type=="questionlist_custom_points"||type=="questionlist_nonconformity_count"||type=="section_points"||type=="section_nonconformities"||type=="inputfield_point")
        {
          if(filter_obj.value && filter_obj.value.length)
          {
            if(filter_obj.value[1] || filter_obj.value[0])
            {
              obj.max = filter_obj.value[1]
              obj.min = filter_obj.value[0]
              arr.push(obj)
            }
          }
        }
        ////////////
        if(type=="inputfield_submission")
        {
          if(filter_obj.value && filter_obj.value.length)
          {
            if(filter_obj.object_type)
            {

              if(filter_obj.object_type=="select")
              {
                let elements = filter_obj.value.map(item=>item)
                obj.ids = elements
                arr.push(obj)
              }
              ////////////
              if(filter_obj.object_type=="number")
              {
                if(filter_obj.value[1] || filter_obj.value[0])
                {
                  obj.max = filter_obj.value[1]
                  obj.min = filter_obj.value[0]
                  arr.push(obj)
                }
              }
              ////////////
              if(filter_obj.object_type=="text")
              {
                if(filter_obj.value)
                {
                  obj.searchterm = filter_obj.value
                  arr.push(obj)
                }
              }
            }
            
          }
        }
        
      }
      let name_val = arr.find(item=>item.type=="name")
      let code_val = arr.find(item=>item.type=="suppliercode")
      if(name_val && code_val)
      {

      }
      return arr
    },
    async getData()
    {
      this.loading  = true
      //let sorted_filters = JSON.stringify(this.sorted_filters)
      console.log("getdata")
      console.log(this.filters)
      let filters = JSON.stringify(this.sortFilters())
      let data = await this.generalApiGetWithoutLoader(`brand_report_data/${this.$route.params.report_id}/${this.page}/${this.rows}?sort_by=${this.sort_column}&sort_order=${this.sort_order}&filters=${filters}`)
     console.log("data")
     console.log(data)
      this.totalRecords = data.total
      
      
      this.listitems =  await data.data

      
      this.loading  = false
    },
    getTitleTranslation(id)
    {
      
      let column = this.columns.find((item)=>{return item.id == id})
      let translation = column.translations.find((item)=>{return item.language_id == this.$store.state.auth.user.preflang_id})
      if(translation)
      {
        
        return translation.translation
      }
      else
      {
               
      
        return column.name
      }
    },
    onPage(event)
    {
        console.log("onPage")
        console.log(event)
        this.page = event.page
        this.getData()
        
    },
    onSort(event)
    {        
        console.log("onSort")
        console.log(event)
        //return false
        this.sort_column = event.sortField
        this.sort_order = event.sortOrder
        this.getData()
    },
    onFilter(event)
    {
        //console.log("filter")
        this.page = 0
        this.last_searched_column
        this.sorted_filters = null
        this.filters = event.filters
        let name_val = this.filters.name.value
        let code_val = this.filters.suppliercode.value
        if(name_val && !code_val)
        {
          this.last_searched_column = "name"
        }
        if(!name_val && code_val)
        {
          this.last_searched_column = "suppliercode"
        }
        if(name_val && code_val)
        {
          if(this.last_searched_column=="name" && code_val)
          {
            this.filters.name.value = null
            this.last_searched_column = "suppliercode"
          }
          if(this.last_searched_column=="suppliercode" && name_val)
          {
            this.filters.suppliercode.value = null
            this.last_searched_column = "name"
          }
        }



        
        this.$emit('updateRequestFilters', this.filters)
        //console.log(this.filters)
        this.getData()
    },
  }
}
</script>

<style lang="scss" scoped>
  .percentage_wrap{
    width:50%;
  }
.loading_overlay
{
    background-color:rgba(53, 47, 141, 0.5);
    width:100%;
    height:100%;
    display:flex;
    justify-content:center;
    align-items:center;
    color:#fff;
    flex-direction:column;

}
::v-deep(.p-paginator) {
    .p-paginator-current {
        margin-left: auto;
    }
}

::v-deep(.p-progressbar) {
    height: .5rem;
    background-color: #D8DADC;

    .p-progressbar-value {
        background-color: #352f8d;
    }
}

::v-deep(.p-datepicker) {
    min-width: 25rem;

    td {
        font-weight: 400;
    }
}

::v-deep(.p-datatable.p-datatable-suppliers) {
    .p-datatable-header {
        padding: 1rem;
        text-align: left;
        font-size: 1.5rem;
    }

    .p-paginator {
        padding: 1rem;
    }

    .p-datatable-thead > tr > th {
        text-align: left;
    }

    .p-datatable-tbody > tr > td {
        cursor: auto;
    }

    .p-dropdown-label:not(.p-placeholder) {
        text-transform: uppercase;
    }
}
</style>